/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SpeisekarteImport } from './routes/speisekarte'
import { Route as PlakateImport } from './routes/plakate'
import { Route as NuclinoSsoImport } from './routes/nuclino-sso'
import { Route as MitgliedsantragImport } from './routes/mitgliedsantrag'
import { Route as LogoImport } from './routes/logo'
import { Route as LineupImport } from './routes/lineup'
import { Route as LearnImport } from './routes/learn'
import { Route as InfosImport } from './routes/infos'
import { Route as EventsImport } from './routes/events'
import { Route as BookingImport } from './routes/booking'
import { Route as BadgesImport } from './routes/badges'
import { Route as AngebotImport } from './routes/angebot'
import { Route as SlugImport } from './routes/$slug'
import { Route as IndexImport } from './routes/index'
import { Route as LineupIndexImport } from './routes/lineup.index'
import { Route as NewsArchivImport } from './routes/news.archiv'
import { Route as NewsSlugImport } from './routes/news.$slug'
import { Route as MitgliedsantragDankeImport } from './routes/mitgliedsantrag.danke'
import { Route as LineupYearImport } from './routes/lineup.$year'
import { Route as EventsIdImport } from './routes/events_.$id'
import { Route as BookingApplicationTypeImport } from './routes/booking_.$applicationType'
import { Route as HashImport } from './routes/$$$.$hash'
import { Route as LineupYearSlugImport } from './routes/lineup.$year_.$slug'
import { Route as BookingApplicationTypeDankeImport } from './routes/booking_.$applicationType_.danke'

// Create/Update Routes

const SpeisekarteRoute = SpeisekarteImport.update({
  id: '/speisekarte',
  path: '/speisekarte',
  getParentRoute: () => rootRoute,
} as any)

const PlakateRoute = PlakateImport.update({
  id: '/plakate',
  path: '/plakate',
  getParentRoute: () => rootRoute,
} as any)

const NuclinoSsoRoute = NuclinoSsoImport.update({
  id: '/nuclino-sso',
  path: '/nuclino-sso',
  getParentRoute: () => rootRoute,
} as any)

const MitgliedsantragRoute = MitgliedsantragImport.update({
  id: '/mitgliedsantrag',
  path: '/mitgliedsantrag',
  getParentRoute: () => rootRoute,
} as any)

const LogoRoute = LogoImport.update({
  id: '/logo',
  path: '/logo',
  getParentRoute: () => rootRoute,
} as any)

const LineupRoute = LineupImport.update({
  id: '/lineup',
  path: '/lineup',
  getParentRoute: () => rootRoute,
} as any)

const LearnRoute = LearnImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => rootRoute,
} as any)

const InfosRoute = InfosImport.update({
  id: '/infos',
  path: '/infos',
  getParentRoute: () => rootRoute,
} as any)

const EventsRoute = EventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRoute,
} as any)

const BookingRoute = BookingImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => rootRoute,
} as any)

const BadgesRoute = BadgesImport.update({
  id: '/badges',
  path: '/badges',
  getParentRoute: () => rootRoute,
} as any)

const AngebotRoute = AngebotImport.update({
  id: '/angebot',
  path: '/angebot',
  getParentRoute: () => rootRoute,
} as any)

const SlugRoute = SlugImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LineupIndexRoute = LineupIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LineupRoute,
} as any)

const NewsArchivRoute = NewsArchivImport.update({
  id: '/news/archiv',
  path: '/news/archiv',
  getParentRoute: () => rootRoute,
} as any)

const NewsSlugRoute = NewsSlugImport.update({
  id: '/news/$slug',
  path: '/news/$slug',
  getParentRoute: () => rootRoute,
} as any)

const MitgliedsantragDankeRoute = MitgliedsantragDankeImport.update({
  id: '/danke',
  path: '/danke',
  getParentRoute: () => MitgliedsantragRoute,
} as any)

const LineupYearRoute = LineupYearImport.update({
  id: '/$year',
  path: '/$year',
  getParentRoute: () => LineupRoute,
} as any)

const EventsIdRoute = EventsIdImport.update({
  id: '/events_/$id',
  path: '/events/$id',
  getParentRoute: () => rootRoute,
} as any)

const BookingApplicationTypeRoute = BookingApplicationTypeImport.update({
  id: '/booking_/$applicationType',
  path: '/booking/$applicationType',
  getParentRoute: () => rootRoute,
} as any)

const HashRoute = HashImport.update({
  id: '/$$$/$hash',
  path: '/$$$/$hash',
  getParentRoute: () => rootRoute,
} as any)

const LineupYearSlugRoute = LineupYearSlugImport.update({
  id: '/$year_/$slug',
  path: '/$year/$slug',
  getParentRoute: () => LineupRoute,
} as any)

const BookingApplicationTypeDankeRoute =
  BookingApplicationTypeDankeImport.update({
    id: '/booking_/$applicationType_/danke',
    path: '/booking/$applicationType/danke',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugImport
      parentRoute: typeof rootRoute
    }
    '/angebot': {
      id: '/angebot'
      path: '/angebot'
      fullPath: '/angebot'
      preLoaderRoute: typeof AngebotImport
      parentRoute: typeof rootRoute
    }
    '/badges': {
      id: '/badges'
      path: '/badges'
      fullPath: '/badges'
      preLoaderRoute: typeof BadgesImport
      parentRoute: typeof rootRoute
    }
    '/booking': {
      id: '/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof BookingImport
      parentRoute: typeof rootRoute
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsImport
      parentRoute: typeof rootRoute
    }
    '/infos': {
      id: '/infos'
      path: '/infos'
      fullPath: '/infos'
      preLoaderRoute: typeof InfosImport
      parentRoute: typeof rootRoute
    }
    '/learn': {
      id: '/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof LearnImport
      parentRoute: typeof rootRoute
    }
    '/lineup': {
      id: '/lineup'
      path: '/lineup'
      fullPath: '/lineup'
      preLoaderRoute: typeof LineupImport
      parentRoute: typeof rootRoute
    }
    '/logo': {
      id: '/logo'
      path: '/logo'
      fullPath: '/logo'
      preLoaderRoute: typeof LogoImport
      parentRoute: typeof rootRoute
    }
    '/mitgliedsantrag': {
      id: '/mitgliedsantrag'
      path: '/mitgliedsantrag'
      fullPath: '/mitgliedsantrag'
      preLoaderRoute: typeof MitgliedsantragImport
      parentRoute: typeof rootRoute
    }
    '/nuclino-sso': {
      id: '/nuclino-sso'
      path: '/nuclino-sso'
      fullPath: '/nuclino-sso'
      preLoaderRoute: typeof NuclinoSsoImport
      parentRoute: typeof rootRoute
    }
    '/plakate': {
      id: '/plakate'
      path: '/plakate'
      fullPath: '/plakate'
      preLoaderRoute: typeof PlakateImport
      parentRoute: typeof rootRoute
    }
    '/speisekarte': {
      id: '/speisekarte'
      path: '/speisekarte'
      fullPath: '/speisekarte'
      preLoaderRoute: typeof SpeisekarteImport
      parentRoute: typeof rootRoute
    }
    '/$$$/$hash': {
      id: '/$$$/$hash'
      path: '/$$$/$hash'
      fullPath: '/$$$/$hash'
      preLoaderRoute: typeof HashImport
      parentRoute: typeof rootRoute
    }
    '/booking_/$applicationType': {
      id: '/booking_/$applicationType'
      path: '/booking/$applicationType'
      fullPath: '/booking/$applicationType'
      preLoaderRoute: typeof BookingApplicationTypeImport
      parentRoute: typeof rootRoute
    }
    '/events_/$id': {
      id: '/events_/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof EventsIdImport
      parentRoute: typeof rootRoute
    }
    '/lineup/$year': {
      id: '/lineup/$year'
      path: '/$year'
      fullPath: '/lineup/$year'
      preLoaderRoute: typeof LineupYearImport
      parentRoute: typeof LineupImport
    }
    '/mitgliedsantrag/danke': {
      id: '/mitgliedsantrag/danke'
      path: '/danke'
      fullPath: '/mitgliedsantrag/danke'
      preLoaderRoute: typeof MitgliedsantragDankeImport
      parentRoute: typeof MitgliedsantragImport
    }
    '/news/$slug': {
      id: '/news/$slug'
      path: '/news/$slug'
      fullPath: '/news/$slug'
      preLoaderRoute: typeof NewsSlugImport
      parentRoute: typeof rootRoute
    }
    '/news/archiv': {
      id: '/news/archiv'
      path: '/news/archiv'
      fullPath: '/news/archiv'
      preLoaderRoute: typeof NewsArchivImport
      parentRoute: typeof rootRoute
    }
    '/lineup/': {
      id: '/lineup/'
      path: '/'
      fullPath: '/lineup/'
      preLoaderRoute: typeof LineupIndexImport
      parentRoute: typeof LineupImport
    }
    '/booking_/$applicationType_/danke': {
      id: '/booking_/$applicationType_/danke'
      path: '/booking/$applicationType/danke'
      fullPath: '/booking/$applicationType/danke'
      preLoaderRoute: typeof BookingApplicationTypeDankeImport
      parentRoute: typeof rootRoute
    }
    '/lineup/$year_/$slug': {
      id: '/lineup/$year_/$slug'
      path: '/$year/$slug'
      fullPath: '/lineup/$year/$slug'
      preLoaderRoute: typeof LineupYearSlugImport
      parentRoute: typeof LineupImport
    }
  }
}

// Create and export the route tree

interface LineupRouteChildren {
  LineupYearRoute: typeof LineupYearRoute
  LineupIndexRoute: typeof LineupIndexRoute
  LineupYearSlugRoute: typeof LineupYearSlugRoute
}

const LineupRouteChildren: LineupRouteChildren = {
  LineupYearRoute: LineupYearRoute,
  LineupIndexRoute: LineupIndexRoute,
  LineupYearSlugRoute: LineupYearSlugRoute,
}

const LineupRouteWithChildren =
  LineupRoute._addFileChildren(LineupRouteChildren)

interface MitgliedsantragRouteChildren {
  MitgliedsantragDankeRoute: typeof MitgliedsantragDankeRoute
}

const MitgliedsantragRouteChildren: MitgliedsantragRouteChildren = {
  MitgliedsantragDankeRoute: MitgliedsantragDankeRoute,
}

const MitgliedsantragRouteWithChildren = MitgliedsantragRoute._addFileChildren(
  MitgliedsantragRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/angebot': typeof AngebotRoute
  '/badges': typeof BadgesRoute
  '/booking': typeof BookingRoute
  '/events': typeof EventsRoute
  '/infos': typeof InfosRoute
  '/learn': typeof LearnRoute
  '/lineup': typeof LineupRouteWithChildren
  '/logo': typeof LogoRoute
  '/mitgliedsantrag': typeof MitgliedsantragRouteWithChildren
  '/nuclino-sso': typeof NuclinoSsoRoute
  '/plakate': typeof PlakateRoute
  '/speisekarte': typeof SpeisekarteRoute
  '/$$$/$hash': typeof HashRoute
  '/booking/$applicationType': typeof BookingApplicationTypeRoute
  '/events/$id': typeof EventsIdRoute
  '/lineup/$year': typeof LineupYearRoute
  '/mitgliedsantrag/danke': typeof MitgliedsantragDankeRoute
  '/news/$slug': typeof NewsSlugRoute
  '/news/archiv': typeof NewsArchivRoute
  '/lineup/': typeof LineupIndexRoute
  '/booking/$applicationType/danke': typeof BookingApplicationTypeDankeRoute
  '/lineup/$year/$slug': typeof LineupYearSlugRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/angebot': typeof AngebotRoute
  '/badges': typeof BadgesRoute
  '/booking': typeof BookingRoute
  '/events': typeof EventsRoute
  '/infos': typeof InfosRoute
  '/learn': typeof LearnRoute
  '/logo': typeof LogoRoute
  '/mitgliedsantrag': typeof MitgliedsantragRouteWithChildren
  '/nuclino-sso': typeof NuclinoSsoRoute
  '/plakate': typeof PlakateRoute
  '/speisekarte': typeof SpeisekarteRoute
  '/$$$/$hash': typeof HashRoute
  '/booking/$applicationType': typeof BookingApplicationTypeRoute
  '/events/$id': typeof EventsIdRoute
  '/lineup/$year': typeof LineupYearRoute
  '/mitgliedsantrag/danke': typeof MitgliedsantragDankeRoute
  '/news/$slug': typeof NewsSlugRoute
  '/news/archiv': typeof NewsArchivRoute
  '/lineup': typeof LineupIndexRoute
  '/booking/$applicationType/danke': typeof BookingApplicationTypeDankeRoute
  '/lineup/$year/$slug': typeof LineupYearSlugRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/angebot': typeof AngebotRoute
  '/badges': typeof BadgesRoute
  '/booking': typeof BookingRoute
  '/events': typeof EventsRoute
  '/infos': typeof InfosRoute
  '/learn': typeof LearnRoute
  '/lineup': typeof LineupRouteWithChildren
  '/logo': typeof LogoRoute
  '/mitgliedsantrag': typeof MitgliedsantragRouteWithChildren
  '/nuclino-sso': typeof NuclinoSsoRoute
  '/plakate': typeof PlakateRoute
  '/speisekarte': typeof SpeisekarteRoute
  '/$$$/$hash': typeof HashRoute
  '/booking_/$applicationType': typeof BookingApplicationTypeRoute
  '/events_/$id': typeof EventsIdRoute
  '/lineup/$year': typeof LineupYearRoute
  '/mitgliedsantrag/danke': typeof MitgliedsantragDankeRoute
  '/news/$slug': typeof NewsSlugRoute
  '/news/archiv': typeof NewsArchivRoute
  '/lineup/': typeof LineupIndexRoute
  '/booking_/$applicationType_/danke': typeof BookingApplicationTypeDankeRoute
  '/lineup/$year_/$slug': typeof LineupYearSlugRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/angebot'
    | '/badges'
    | '/booking'
    | '/events'
    | '/infos'
    | '/learn'
    | '/lineup'
    | '/logo'
    | '/mitgliedsantrag'
    | '/nuclino-sso'
    | '/plakate'
    | '/speisekarte'
    | '/$$$/$hash'
    | '/booking/$applicationType'
    | '/events/$id'
    | '/lineup/$year'
    | '/mitgliedsantrag/danke'
    | '/news/$slug'
    | '/news/archiv'
    | '/lineup/'
    | '/booking/$applicationType/danke'
    | '/lineup/$year/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug'
    | '/angebot'
    | '/badges'
    | '/booking'
    | '/events'
    | '/infos'
    | '/learn'
    | '/logo'
    | '/mitgliedsantrag'
    | '/nuclino-sso'
    | '/plakate'
    | '/speisekarte'
    | '/$$$/$hash'
    | '/booking/$applicationType'
    | '/events/$id'
    | '/lineup/$year'
    | '/mitgliedsantrag/danke'
    | '/news/$slug'
    | '/news/archiv'
    | '/lineup'
    | '/booking/$applicationType/danke'
    | '/lineup/$year/$slug'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/angebot'
    | '/badges'
    | '/booking'
    | '/events'
    | '/infos'
    | '/learn'
    | '/lineup'
    | '/logo'
    | '/mitgliedsantrag'
    | '/nuclino-sso'
    | '/plakate'
    | '/speisekarte'
    | '/$$$/$hash'
    | '/booking_/$applicationType'
    | '/events_/$id'
    | '/lineup/$year'
    | '/mitgliedsantrag/danke'
    | '/news/$slug'
    | '/news/archiv'
    | '/lineup/'
    | '/booking_/$applicationType_/danke'
    | '/lineup/$year_/$slug'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRoute
  AngebotRoute: typeof AngebotRoute
  BadgesRoute: typeof BadgesRoute
  BookingRoute: typeof BookingRoute
  EventsRoute: typeof EventsRoute
  InfosRoute: typeof InfosRoute
  LearnRoute: typeof LearnRoute
  LineupRoute: typeof LineupRouteWithChildren
  LogoRoute: typeof LogoRoute
  MitgliedsantragRoute: typeof MitgliedsantragRouteWithChildren
  NuclinoSsoRoute: typeof NuclinoSsoRoute
  PlakateRoute: typeof PlakateRoute
  SpeisekarteRoute: typeof SpeisekarteRoute
  HashRoute: typeof HashRoute
  BookingApplicationTypeRoute: typeof BookingApplicationTypeRoute
  EventsIdRoute: typeof EventsIdRoute
  NewsSlugRoute: typeof NewsSlugRoute
  NewsArchivRoute: typeof NewsArchivRoute
  BookingApplicationTypeDankeRoute: typeof BookingApplicationTypeDankeRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRoute,
  AngebotRoute: AngebotRoute,
  BadgesRoute: BadgesRoute,
  BookingRoute: BookingRoute,
  EventsRoute: EventsRoute,
  InfosRoute: InfosRoute,
  LearnRoute: LearnRoute,
  LineupRoute: LineupRouteWithChildren,
  LogoRoute: LogoRoute,
  MitgliedsantragRoute: MitgliedsantragRouteWithChildren,
  NuclinoSsoRoute: NuclinoSsoRoute,
  PlakateRoute: PlakateRoute,
  SpeisekarteRoute: SpeisekarteRoute,
  HashRoute: HashRoute,
  BookingApplicationTypeRoute: BookingApplicationTypeRoute,
  EventsIdRoute: EventsIdRoute,
  NewsSlugRoute: NewsSlugRoute,
  NewsArchivRoute: NewsArchivRoute,
  BookingApplicationTypeDankeRoute: BookingApplicationTypeDankeRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$slug",
        "/angebot",
        "/badges",
        "/booking",
        "/events",
        "/infos",
        "/learn",
        "/lineup",
        "/logo",
        "/mitgliedsantrag",
        "/nuclino-sso",
        "/plakate",
        "/speisekarte",
        "/$$$/$hash",
        "/booking_/$applicationType",
        "/events_/$id",
        "/news/$slug",
        "/news/archiv",
        "/booking_/$applicationType_/danke"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$slug": {
      "filePath": "$slug.tsx"
    },
    "/angebot": {
      "filePath": "angebot.tsx"
    },
    "/badges": {
      "filePath": "badges.tsx"
    },
    "/booking": {
      "filePath": "booking.tsx"
    },
    "/events": {
      "filePath": "events.tsx"
    },
    "/infos": {
      "filePath": "infos.tsx"
    },
    "/learn": {
      "filePath": "learn.tsx"
    },
    "/lineup": {
      "filePath": "lineup.tsx",
      "children": [
        "/lineup/$year",
        "/lineup/",
        "/lineup/$year_/$slug"
      ]
    },
    "/logo": {
      "filePath": "logo.tsx"
    },
    "/mitgliedsantrag": {
      "filePath": "mitgliedsantrag.tsx",
      "children": [
        "/mitgliedsantrag/danke"
      ]
    },
    "/nuclino-sso": {
      "filePath": "nuclino-sso.tsx"
    },
    "/plakate": {
      "filePath": "plakate.tsx"
    },
    "/speisekarte": {
      "filePath": "speisekarte.tsx"
    },
    "/$$$/$hash": {
      "filePath": "$$$.$hash.tsx"
    },
    "/booking_/$applicationType": {
      "filePath": "booking_.$applicationType.tsx"
    },
    "/events_/$id": {
      "filePath": "events_.$id.tsx"
    },
    "/lineup/$year": {
      "filePath": "lineup.$year.tsx",
      "parent": "/lineup"
    },
    "/mitgliedsantrag/danke": {
      "filePath": "mitgliedsantrag.danke.tsx",
      "parent": "/mitgliedsantrag"
    },
    "/news/$slug": {
      "filePath": "news.$slug.tsx"
    },
    "/news/archiv": {
      "filePath": "news.archiv.tsx"
    },
    "/lineup/": {
      "filePath": "lineup.index.tsx",
      "parent": "/lineup"
    },
    "/booking_/$applicationType_/danke": {
      "filePath": "booking_.$applicationType_.danke.tsx"
    },
    "/lineup/$year_/$slug": {
      "filePath": "lineup.$year_.$slug.tsx",
      "parent": "/lineup"
    }
  }
}
ROUTE_MANIFEST_END */
